function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSezione05Popup04Ico01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 119.71 119.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M96.38,13.91c-1.3-.01-2.57.31-3.62,1.09-2.02,1.49-1.89,4.94-.58,6.6,1.52,1.91,4.33,1.04,5.24,3.03.3.65.38,1.59,0,2.35-.91,1.8-3.78,1.09-5.06,3.09-.53.83-.54,1.72-.52,2.07.11,2.23,3.07,3.61,2.98,5.85-.06,1.46-1.39,2.49-2.58,3.33-3.92,2.78-3.8,8.1-4.02,10.15-.29,2.69-.88,8.07,2.16,10.74,4.02,3.53,10.41-1.21,14.09,2.35,2.02,1.95,1.05,4.29,2.35,9.39,1.33,5.25,3.95,9.09,5.9,11.46,3.74-7.73,5.84-16.39,5.84-25.55,0-18.61-8.67-35.18-22.18-45.94Z",
    style: {
      fill: "none",
      stroke: "#92bb44",
      strokeLinejoin: "round",
      strokeWidth: "2.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.45,57.3c5,10.97,1.84,30.8-10.46,40.66-9.2,7.38-22.13,7.02-29.03-1-6.9-8.02-5.09-20.57,4.05-28.04,9.13-7.47,23.85-3.03,35.44-11.62Z",
    style: {
      fill: "none",
      stroke: "#92bb44",
      strokeLinejoin: "round",
      strokeWidth: "2.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.93,59.29c-1.23-1.44-2.08-3.12-2.31-5.12-.29-2.6.53-4.17.71-4.52,1.23-2.46,3.97-4.02,6.72-3.72,3.59.39,5.2,3.95,7.11,6.57.95-.04,1.55-1.14,1.48-2.1-.06-.95-.56-1.82-.86-2.72,0,0-.24-1.24.25-2.72.92-2.75,4.37-2.33,6.52-4.82,2.22-2.58.1-4.86,1.74-8.37,2.46-5.29,9.03-3.91,10.21-7.66,1.62-5.15-8.66-14.6-15.38-13.74-1.06.13-1.77.44-1.95.6-2.21,1.99,1.04,8.4-3.74,10.79-5.69,0-8.54-8.54-14.23-8.54.99-2.21,1.99-4.42,2.98-6.64-11.02,5.11-20.17,13.53-26.21,24,1.21,6.03,3.23,10.71,4.94,13.96,2.14,4.06,7.05,13.35,17.08,18.81M57.3,80.27c-9.53,1.82-18.21,7.36-23.89,14.44-5.38,6.72-2.78,16.79,5.24,19.9,6.57,2.55,13.72,3.94,21.19,3.94M59.85,118.56c32.42,0,58.7-26.28,58.7-58.7S92.27,1.15,59.85,1.15,1.15,27.43,1.15,59.85c0,16.19,6.55,30.84,17.14,41.46",
    style: {
      fill: "none",
      stroke: "#92bb44",
      strokeLinejoin: "round",
      strokeWidth: "2.3px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSezione05Popup04Ico01);
export default __webpack_public_path__ + "static/media/sezione-05-popup-04-ico-01.24363a8ff9e70a8914fe183a1882957d.svg";
export { ForwardRef as ReactComponent };